import ClientDetailTabCorporate from '@/components/client/corporate/DetailTabCorporate.vue'
import ClientInnerTabCorporateCaptable from '@/components/client/corporate/InnerTabCorporateCaptable.vue'
import ClientInnerTabCorporateAdministration from '@/components/client/corporate/InnerTabCorporateAdministration.vue'
import ClientInnerTabCorporateHistoric from '@/components/client/corporate/InnerTabCorporateHistoric.vue'

const corporateRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: '',
        path: `${basePath}/detalhe/:id/societario/captable`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default'
        },
        props: true,
        component: ClientDetailTabCorporate,
        children: [
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaSocietarioCaptable`,
                path: '',
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    basePath,
                    singleName,
                    tabs
                },
                props: true,
                component: ClientInnerTabCorporateCaptable
            },
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaSocietarioAdministracao`,
                path: `${basePath}/detalhe/:id/societario/administracao`,
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    basePath,
                    singleName,
                    tabs
                },
                props: true,
                component: ClientInnerTabCorporateAdministration
            },
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaSocietarioAtoConstitutivo`,
                path: `${basePath}/detalhe/:id/societario/atos-constitutivos`,
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    basePath,
                    singleName,
                    tabs
                },
                props: true,
                component: ClientInnerTabCorporateHistoric
            }
        ]
    }
}

export default corporateRouter
